"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ACCESSORIES = void 0;
var _checkmark = _interopRequireDefault(require("@ux/icon/checkmark"));
var _information = _interopRequireDefault(require("@ux/icon/information"));
var _comment = _interopRequireDefault(require("@ux/icon/comment"));
var _alert = _interopRequireDefault(require("@ux/icon/alert"));
var _help = _interopRequireDefault(require("@ux/icon/help"));
var _star = _interopRequireDefault(require("@ux/icon/star"));
/**
 * Type to icon mapping. Can be extended with more types if needed.
 *
 * @type {Object}
 * @public
 */
const ACCESSORIES = exports.ACCESSORIES = {
  critical: _alert.default,
  warning: _alert.default,
  highlight: _star.default,
  success: _checkmark.default,
  info: _information.default,
  neutral: _help.default,
  internal: _comment.default
};